<i18n>
{
  "fr": {
    "project-list-name-label": "Nom",
    "project-list-province-label" : "Province",
    "project-list-status-label": "Statut",
    "project-list-documents-label": "Documents complétés",
    "project-list-specific-label": "Spécifications"
  },
  "en": {
    "project-list-name-label": "Name",
    "project-list-province-label" : "Province",
    "project-list-status-label": "Status",
    "project-list-documents-label": "Completed documents",
    "project-list-specific-label": "Specifications"
  }
}
</i18n>

<template>
  <div>
    <s-loader :active="!projects && loading" />
    <b-table
      v-if="projects !== null"
      :data="projects"
      :loading="loading"
      :current-page="currentPage"
      :total="totalCount"
      :per-page="perPage"
      :paginated="isPaginated"
      :default-sort="[sortField, sortOrder]"
      backend-pagination
      backend-sorting
      @page-change="onPageChange"
      @sort="onSortChange"
      class="project-list-table"
    >
      <b-table-column
        v-slot="props"
        cell-class="has-text-weight-medium"
        field="name"
        :label="$t('project-list-name-label')"
        sortable
      >
        <router-link :to="{ name: URL_PROJECT_COMPLIANCE, params: { projectId: props.row.id } }">
          {{ props.row.name }}
        </router-link>
      </b-table-column>

      <b-table-column
        v-slot="props"
        cell-class="has-text-weight-medium"
        field="provinceCode"
        :label="$t('project-list-province-label')"
        sortable
      >
        {{ getProvinceTranslation(props.row.provinceCode) }}
      </b-table-column>

      <b-table-column
        v-slot="props"
        field="documents"
        :label="$t('project-list-documents-label')"
        header-class="project-list-documents-header"
        sortable
      >
        {{ props.row.stats.directDocumentsCompletedCount }}/{{ props.row.stats.directDocumentsCount }}
      </b-table-column>

      <b-table-column
        v-slot="props"
        field="specifications"
        :label="$t('project-list-specific-label')"
        header-class="project-list-specific-header"
        sortable
      >
        <span>{{ props.row.stats.directIndicatorsCount }} &nbsp;<img :src="require('@/assets/icon-specific.svg')" /></span>
      </b-table-column>

      <b-table-column
        v-slot="props"
        field="status"
        :label="$t('project-list-status-label')"
        header-class="project-list-status-header"
        sortable
      >
        <project-status-badge :status="props.row.status" />
      </b-table-column>
      <b-table-column v-slot="{ row }">
        <b-field class="row-tools is-grouped is-grouped-right">
          <p class="control">
            <b-button outlined size="is-small" @click="deleteProject(row)">
              <span class="icon is-small has-text-link"><i class="far fa-trash-alt" /></span>
            </b-button>
          </p>
        </b-field>
      </b-table-column>
    </b-table>
  </div>
</template>

<script>
import { URL_PROJECT_COMPLIANCE } from '@/consts/urls'
import ProjectStatusBadge from '@/components/projects/project-status-badge'
import ProvinceService from '@/services/province'

export default {
  components: {
    ProjectStatusBadge
  },
  props: {
    loading: { type: Boolean },
    projects: {
      type: Array,
      default() {
        return []
      }
    },
    currentPage: {
      type: Number,
      default() {
        return 1
      }
    },
    sortField: {
      type: String,
      default() {
        return 'status'
      }
    },
    sortOrder: {
      type: String,
      default() {
        return 'asc'
      }
    },
    totalCount: {
      type: Number,
      default() {
        return 0
      }
    },
    totalPages: {
      type: Number,
      default() {
        return 1
      }
    },
    perPage: {
      type: Number,
      required: true
    }
  },

  data() {
    return { URL_PROJECT_COMPLIANCE }
  },

  computed: {
    isPaginated: function () {
      return this.totalPages > 1
    }
  },

  methods: {
    onPageChange(page) {
      this.$emit('pageChange', { page })
    },
    onSortChange(field, order) {
      this.$emit('sortChange', { field, order })
    },
    deleteProject(row) {
      this.$emit('deleteProject', { project: row })
    },
    getProvinceTranslation(provinceCode) {
      return ProvinceService.getProvinceTranslation(provinceCode)
    }
  }
}
</script>

<style lang="scss">
@include tablet {
  th.project-list-status-header {
    max-width: 120px;
  }

  th.project-list-documents-header {
    max-width: 140px;
  }

  th.project-list-specific-header {
    max-width: 100px;
  }
}

@include desktop {
  .project-list-table {
    tr {
      .field.row-tools {
        opacity: 0;
      }

      &:hover .field.row-tools {
        opacity: 1;
      }
    }
  }
}
</style>
